'use strict';

wbApp.controller('ConsentsDefinitionsCtrl', ['$scope', '$http', '$q', '$modal', '$translate', '$filter', 'messageBoxSvc',
    'consentDefinitionSvc', 'gridSortSvc',
function ($scope, $http, $q, $modal, $translate, $filter, messageBoxSvc,
    consentDefinitionSvc, gridSortSvc) {

    $scope.gridSettings = {
        name: 'consentsDefinitions',
        columns: [
            {
                dataField: 'consentTypeID',
                caption: $translate.instant("TXT_CONSENT_TYPE"),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('wbConsentType')(rowData.consentTypeID);
                },
                width: '90px'
            },
            { dataField: 'name', caption: $translate.instant('TXT_NAME'), dataType: 'string', sortOrder: 'asc' },
            { dataField: 'validFrom', caption: $translate.instant('TXT_LAB_VALID_FROM'), dataType: 'date', format: { date: 'short' }, width: '90px' },
            { dataField: 'validTo', caption: $translate.instant('TXT_LAB_VALID_TO'), dataType: 'date', format: { date: 'short' }, width: '90px' },
            { dataField: 'validToDays', caption: $translate.instant('TXT_LBL_VALID_FOR_DAYS'), dataType: 'number', width: '90px' },
            { dataField: 'active', caption: $translate.instant('TXT_LBL_ACTIVE'), dataType: 'boolean', width: '60px' },
        ]
    }

    function loadData(refresh) {
        $scope.consentsDefinitions = consentDefinitionSvc.getAllAsync(refresh);
    }

    loadData(true);

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = consentDefinitionSvc.createNew();
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        consentDefinitionSvc.remove(data);
    }

    var detailDialogPromise = $modal({
        templateUrl: 'users/users-consents/consents-definitions-detail.html',
        show: false,
        scope: $scope.$new()
    });

}]);


